import React, { Component } from "react";
import { get as _get, isEqual as _isEqual } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { showAlertMessage, Select, RenderTableHeaderValue, RenderTableCellValue, DateRangePicker } from "../../../resusableComponents/common/formElements";

import { withRouter } from "../../../resusableComponents/hoc/withRouter";
import ReactDataTable from "../../../resusableComponents/common/ReactDataTable";

import { getExportHistoryData } from "../../../redux/services/history";
import { getUserList } from "../../../redux/services/user";

import { updatePageLevelLoadingState } from "../../../redux/actions/application";
import { thousandSeparator } from "../../../helpers/utils";

class ExportTab extends Component {

  constructor(props) {
    super(props);
    const { intl } = props;

    this.defaultPayload = {
      user_ids: null,
      start_date: "",
      end_date: "",
      page_no: 1,
      page_size: 100,
      orderby: "id",
      order: "desc"
    };

    this.state = {
      defaultPayload: { ...this.defaultPayload },
      userList: [],
      selectedUsers: null,
      page_no: 1,
      page_size: 100,
      exportHistoryData: {},
      activeRequestCount: 0,
      refreshTable: false,
      resetDateRangePicker: false
    };

    this.tableColumns = [
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.status", defaultMessage: "status" })} />),
        selector: (row) => (_get(row, "status_text", "")),
        cell: (row) => (<RenderTableCellValue className={_get(row, "color_code", "")} value={_get(row, "status_text", "")} />),
        sortable: true,
        sortField: "status_text",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.date", defaultMessage: "date" })} />),
        selector: (row) => (_get(row, "created_at", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "created_at", "")} />),
        sortable: true,
        sortField: "created_at",
        grow: 1
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.id", defaultMessage: "ID" })} />),
        selector: (row) => (_get(row, "id", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "id", "")} />),
        sortable: true,
        sortField: "id",
        grow: 0.6
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.export_name", defaultMessage: "export name" })} />),
        selector: (row) => (_get(row, "export_name", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "export_name", "")} />),
        sortable: true,
        sortField: "export_name",
        grow: 2
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.records", defaultMessage: "records" })} />),
        selector: (row) => (_get(row, "record_count", "")),
        cell: (row) => (<RenderTableCellValue value={thousandSeparator(_get(row, "record_count", 0))} className="ms-2" />),
        sortable: false,
        grow: 0.8
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.exported_by", defaultMessage: "exported by" })} />),
        selector: (row) => (_get(row, "username", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "username", "")} className="ms-2" />),
        sortable: false,
        sortField: "user_id",
        grow: 1.2
      },
      {
        name: (<RenderTableHeaderValue className="text-capitalize" value={intl.formatMessage({ id: "history.export_table.source", defaultMessage: "source" })} />),
        selector: (row) => (_get(row, "search_type", "")),
        cell: (row) => (<RenderTableCellValue value={_get(row, "search_type", "")} />),
        sortable: true,
        sortField: "search_type",
        grow: 0.4
      }
    ];
  }

  componentDidMount() {
    this._fetchUserList();
    this._fetchExportHistoryData();
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      (!_isEqual(prevState.defaultPayload, this.state.defaultPayload)) ||
      (!_isEqual(prevState.refreshTable, this.state.refreshTable) && (_get(this.state, "refreshTable", false) === true))
    ) {
      this._fetchExportHistoryData();
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchUserList = async () => {
    try {
      this._incrementLoader();

      const response = await getUserList();

      if ((response.flag || false) === true) {
        this.setState({ userList: _get(response, "data", []), selectedUsers: null });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching user list."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching user list."));

    } finally {
      this._decrementLoader();
    }
  }

  _fetchExportHistoryData = async () => {
    const { defaultPayload } = this.state;

    try {
      this._incrementLoader();

      const response = await getExportHistoryData({ ...defaultPayload });

      if ((response.flag || false) === true) {
        this.setState({ exportHistoryData: _get(response, "data", {}), refreshTable: false });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching export history data."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching export history data."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleSort = (column, sortDirection) => {
    this.setState((prevState) => {
      return {
        defaultPayload: {
          ...prevState.defaultPayload,
          page_no: 1,
          orderby: (column.sortField || column.selector || "id"),
          order: sortDirection
        }
      };
    });
  };

  _handleResetFilters = () => {
    this.setState({
      defaultPayload: { ...this.defaultPayload },
      selectedUsers: null,
      page_no: 1,
      page_size: 100,
      refreshTable: false,
      resetDateRangePicker: true
    });
  }

  _handleUpdateDateRange = (startDate, endDate) => {
    const { defaultPayload } = this.state;

    this.setState({
      defaultPayload: {
        ...defaultPayload,
        start_date: (startDate || ""),
        end_date: (endDate || "")
      },
      resetDateRangePicker: false
    });
  }

  _handlePaginationChange = (pageNo) => {
    const { defaultPayload } = this.state;

    this.setState({ defaultPayload: { ...defaultPayload, page_no: pageNo } });
  }

  _renderFilters = () => {
    const { intl } = this.props;
    const { userList, selectedUsers, resetDateRangePicker } = this.state;

    return (
      <div className="row">
        <div className="col-lg-3">
          <div>
            <label className="form-label text-capitalize">
              <FormattedMessage id="date_range_picker.title" defaultMessage="date range" />
            </label>
            <DateRangePicker resetDateRangePicker={(resetDateRangePicker || false)} onChange={(startDate, endDate) => this._handleUpdateDateRange(startDate, endDate)} />
          </div>
        </div>
        <div className="col-lg-3">
          <Select
            options={(userList || [])}
            getOptionLabel={(option) => (option.name || "")}
            getOptionValue={(option) => (option.id || null)}
            placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" },
              { field: intl.formatMessage({ id: "history.label.users", defaultMessage: "Users" }) })}
            label={intl.formatMessage({ id: "history.label.users", defaultMessage: "Users" })}
            value={(selectedUsers || null)}
            onChange={(value) => {
              this.setState((prevState) => ({
                selectedUsers: value, defaultPayload: { ...prevState.defaultPayload, user_ids: [(value.id || null)] }
              }));
            }}
            isMulti={false}
          />
        </div>
        <div className="col-lg-6 d-flex justify-content-end align-items-end">
          <div className="mt-7">
            <button type="button" className="btn btn-dark waves-effect flex-fill text-capitalize" onClick={() => this._handleResetFilters()}>
              <FormattedMessage id="btn.reset" defaultMessage="Reset" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  _renderTableData = () => {
    const { exportHistoryData, defaultPayload } = this.state;

    return (
      <div className="row mt-2">
        <div className="col-lg-12">
          <div className="custom-scroll">
            <ReactDataTable
              className="custom-scroll-460"
              columns={(this.tableColumns || [])}
              data={_get(exportHistoryData, "contact_export", [])}
              pagination={true}
              fixedHeader={false}
              totalRecords={_get(exportHistoryData, "page_info[0].total_records", 0)}
              rowsPerPage={(defaultPayload.page_size || 100)}
              // selectableRows
              onChangePage={(e) => this._handlePaginationChange(e)}
              // onSelectedRowsChange={(selectedRows) => {
              //   const tmpIds = _get(selectedRows, "selectedRows", []).map(row => { return row.id });
              //   this.setState({ selectedIds: tmpIds });
              // }}
              sortServer
              onSort={(colm, order) => this._handleSort(colm, order)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {

    return (
      <>
        {this._renderFilters()}

        {this._renderTableData()}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(ExportTab)));
